module.exports = __webpack_public_path__ + "img/hata no kokoro_sc1.7337190d.png";